(function(){
  var cfgEl=document.getElementById('mm-cart-config');
  if(!cfgEl)return;
  var CFG=JSON.parse(cfgEl.textContent);
  var CUR=CFG.currency||'AUD';
  function money(c){try{return new Intl.NumberFormat('en-AU',{style:'currency',currency:CUR}).format(c/100);}catch(e){return '$'+(c/100).toFixed(2);}}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}
  var ICON={
    close:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v12H1zM14 8h5l3 3v5h-8"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>',
    shield:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 3v6c0 5-3.5 9-8 11-4.5-2-8-6-8-11V5z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    lock:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>',
    trash:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>'
  };

  // ---------- build drawer ----------
  var root=document.createElement('div');
  root.className='mm mmc';
  root.innerHTML=
    '<div class="mmc__scrim" data-mmc-close></div>'+
    '<aside class="mmc__panel" role="dialog" aria-modal="true" aria-label="Your cart" tabindex="-1">'+
      '<header class="mmc__head"><h2>Your cart <span data-mmc-count></span></h2><button type="button" class="mmc__x" data-mmc-close aria-label="Close cart">'+ICON.close+'</button></header>'+
      '<div class="mmc__ship">'+ICON.truck+'<span><b>Free tracked shipping</b> unlocked — Australia-wide</span></div>'+
      '<div class="mmc__body" data-mmc-body></div>'+
      '<footer class="mmc__foot" data-mmc-foot></footer>'+
    '</aside>';
  document.body.appendChild(root);
  var panel=root.querySelector('.mmc__panel');
  var body=root.querySelector('[data-mmc-body]');
  var foot=root.querySelector('[data-mmc-foot]');
  var countEl=root.querySelector('[data-mmc-count]');
  var lastFocus=null, busy=false, cart=null;

  function open(){lastFocus=document.activeElement;root.classList.add('is-open');document.documentElement.classList.add('mmc-lock');setTimeout(function(){panel.focus();},50);}
  function close(){root.classList.remove('is-open');document.documentElement.classList.remove('mmc-lock');if(lastFocus&&lastFocus.focus)lastFocus.focus();}
  root.addEventListener('click',function(e){if(e.target.closest('[data-mmc-close]'))close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('is-open'))close();});

  function api(url,data){
    var opt=data?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)}:{headers:{'Accept':'application/json'}};
    return fetch(url,opt).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});});
  }
  function refresh(){return api('/cart.js').then(function(c){cart=c;render();updateBadges();return c;});}
  function updateBadges(){
    if(!cart)return;
    document.querySelectorAll('[data-mm-cart-count]').forEach(function(b){b.textContent=cart.item_count;b.hidden=!cart.item_count;});
    // Horizon header bubble
    document.querySelectorAll('.cart-bubble__text-count, .cart-count-bubble span').forEach(function(b){b.textContent=cart.item_count;});
  }

  function variantInfo(id){return CFG.variants[String(id)]||null;}

  function upsellHTML(){
    if(!cart||!cart.items.length)return '';
    var setId=CFG.set, smallId=CFG.small;
    var hasSet=cart.items.some(function(i){return i.variant_id===setId;});
    var singles=cart.items.filter(function(i){return CFG.singles.indexOf(i.variant_id)>-1;});
    var setV=variantInfo(setId);
    if(!hasSet&&singles.length&&setV){
      var singlesTotal=singles.reduce(function(s,i){return s+i.final_line_price;},0);
      var diff=setV.p-singlesTotal;
      var line=diff>0?('Get all 3 mats for just <b>'+money(diff)+' more</b>'):('Get all 3 mats and <b>save '+money(-diff)+'</b>');
      return '<div class="mmc__up"><img src="'+esc(setV.img)+'" alt="" width="64" height="64"><div><p class="mmc__up-k">Upgrade &amp; save</p><p class="mmc__up-t">Complete 3-Piece Set</p><p class="mmc__up-s">'+line+'</p></div><button type="button" class="mmc__up-b" data-mmc-upgrade>Upgrade</button></div>';
    }
    var smallV=variantInfo(smallId);
    var hasSmallExtra=cart.items.some(function(i){return i.variant_id===smallId;});
    if(hasSet&&!hasSmallExtra&&smallV){
      return '<div class="mmc__up"><img src="'+esc(smallV.img)+'" alt="" width="64" height="64"><div><p class="mmc__up-k">Popular add-on</p><p class="mmc__up-t">Extra Small mat</p><p class="mmc__up-s">Keep one in the glovebox or tackle box · <b>'+money(smallV.p)+'</b></p></div><button type="button" class="mmc__up-b" data-mmc-add="'+smallId+'">+ Add</button></div>';
    }
    return '';
  }

  function render(){
    if(!cart)return;
    countEl.textContent=cart.item_count?'('+cart.item_count+')':'';
    if(!cart.items.length){
      body.innerHTML='<div class="mmc__empty"><p>Your cart is empty.</p><a href="'+esc(CFG.productUrl)+'" class="mm-btn mm-btn--red" data-mmc-close>Shop MagMats</a></div>';
      foot.innerHTML='';
      return;
    }
    var savings=0;
    var items=cart.items.map(function(i){
      var v=variantInfo(i.variant_id);
      var was=v&&v.c>v.p?v.c*i.quantity:0;
      if(was)savings+=was-i.final_line_price;
      var img=i.image?i.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x200$1$2'):'';
      return '<div class="mmc__item" data-key="'+esc(i.key)+'">'+
        (img?'<img src="'+esc(img)+'" alt="" width="76" height="76">':'')+
        '<div class="mmc__i-info"><p class="mmc__i-t">'+esc(i.product_title)+'</p>'+
        (i.variant_title?'<p class="mmc__i-v">'+esc(i.variant_title)+'</p>':'')+
        '<div class="mmc__i-row"><div class="mmc__qty"><button type="button" data-mmc-qty="-1" aria-label="Decrease quantity">−</button><span>'+i.quantity+'</span><button type="button" data-mmc-qty="1" aria-label="Increase quantity">+</button></div>'+
        '<button type="button" class="mmc__rm" data-mmc-remove aria-label="Remove">'+ICON.trash+'</button></div></div>'+
        '<div class="mmc__i-p"><b>'+money(i.final_line_price)+'</b>'+(was?'<s>'+money(was)+'</s>':'')+'</div>'+
      '</div>';
    }).join('');
    body.innerHTML='<div class="mmc__items">'+items+'</div>'+upsellHTML();
    foot.innerHTML=
      (savings>0?'<div class="mmc__row mmc__row--save"><span>Bundle savings</span><span>−'+money(savings)+'</span></div>':'')+
      '<div class="mmc__row"><span>Shipping</span><span class="mmc__free">FREE</span></div>'+
      '<div class="mmc__row mmc__row--tot"><span>Total</span><span>'+money(cart.total_price)+'</span></div>'+
      '<a href="/checkout" class="mm-btn mm-btn--red mm-btn--block mmc__go">'+ICON.lock+'<span>Checkout securely</span></a>'+
      '<div class="mmc__pay">'+(CFG.payIcons||'')+'</div>'+
      '<div class="mmc__trust"><span>'+ICON.shield+'30-day money-back guarantee</span><span>'+ICON.truck+'Ships in 1–3 business days</span></div>';
  }

  function setBusy(b){busy=b;root.classList.toggle('is-busy',b);}
  function change(key,qty){setBusy(true);return api('/cart/change.js',{id:key,quantity:qty}).then(function(c){cart=c;render();updateBadges();}).catch(function(){return refresh();}).finally(function(){setBusy(false);});}
  function add(items){setBusy(true);return api('/cart/add.js',{items:items}).then(refresh).finally(function(){setBusy(false);});}

  root.addEventListener('click',function(e){
    if(busy)return;
    var it=e.target.closest('.mmc__item');
    var q=e.target.closest('[data-mmc-qty]');
    if(q&&it){var line=cart.items.find(function(i){return i.key===it.dataset.key;});change(it.dataset.key,Math.max(0,line.quantity+parseInt(q.dataset.mmcQty,10)));return;}
    if(e.target.closest('[data-mmc-remove]')&&it){change(it.dataset.key,0);return;}
    var a=e.target.closest('[data-mmc-add]');
    if(a){add([{id:parseInt(a.dataset.mmcAdd,10),quantity:1}]);return;}
    if(e.target.closest('[data-mmc-upgrade]')){
      var updates={};
      cart.items.forEach(function(i){if(CFG.singles.indexOf(i.variant_id)>-1)updates[i.key]=0;});
      setBusy(true);
      api('/cart/update.js',{updates:updates}).then(function(){return api('/cart/add.js',{items:[{id:CFG.set,quantity:1}]});}).then(refresh).catch(refresh).finally(function(){setBusy(false);});
    }
  });

  // ---------- intercept add to cart ----------
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches||!f.matches('form[data-mm-form], form[action*="/cart/add"]'))return;
    e.preventDefault();
    var btn=f.querySelector('[type="submit"]');
    var idIn=f.querySelector('input[name="id"]');
    var qIn=f.querySelector('input[name="quantity"]');
    if(!idIn){f.submit();return;}
    if(btn){btn.classList.add('is-loading');btn.disabled=true;}
    api('/cart/add.js',{items:[{id:parseInt(idIn.value,10),quantity:qIn?parseInt(qIn.value,10)||1:1}]})
      .then(refresh).then(function(){open();})
      .catch(function(){f.submit();})
      .finally(function(){if(btn){btn.classList.remove('is-loading');btn.disabled=false;}});
  },true);

  // ---------- open from header cart icon ----------
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href="/cart"], a[href$="/cart"], [data-mm-open-cart]');
    if(!a||root.contains(a))return;
    e.preventDefault();
    refresh().then(open);
  },true);

  refresh();
  window.MMCart={open:function(){refresh().then(open);},close:close,refresh:refresh};
})();
